import { useIntl } from 'react-intl';
import { TableListV2, Tag } from 'sonata-react-components';

import type { TagStatus } from 'sonata-react-components';
import type { GenericImportRow, GenericImportStatus } from '../AppAndSiteMarketplace.types';

type Props = {
  rows: GenericImportRow[];
};

const TAG_STATUS: Record<GenericImportStatus, TagStatus> = {
  domain: 'ok',
  invalid: 'wrong',
  overLimit: 'warning',
  subdomain: 'information'
};

/** Detail of a generic CSV import: every CSV value with its type and whether it will be added. */
export function GenericImportDetail({ rows }: Readonly<Props>) {
  const { formatMessage } = useIntl();

  const statusLabels: Record<GenericImportStatus, string> = {
    domain: formatMessage({
      defaultMessage: 'Domain',
      id: 'appAndSiteMarketplace.import.status.domain'
    }),
    invalid: formatMessage({
      defaultMessage: 'Invalid',
      id: 'appAndSiteMarketplace.import.status.invalid'
    }),
    overLimit: formatMessage({
      defaultMessage: 'Over limit',
      id: 'appAndSiteMarketplace.import.status.overLimit'
    }),
    subdomain: formatMessage({
      defaultMessage: 'Subdomain',
      id: 'appAndSiteMarketplace.import.status.subdomain'
    })
  };
  const operationLabels = {
    exclude: formatMessage({
      defaultMessage: 'Exclude',
      id: 'appAndSiteMarketplace.inventory.exclude'
    }),
    include: formatMessage({
      defaultMessage: 'Include',
      id: 'appAndSiteMarketplace.inventory.include'
    })
  };

  const data = rows.map(({ id, operation, status, value }) => ({
    id,
    operation: operation ? operationLabels[operation] : '-',
    status: (
      <Tag id={`tag-${id}`} status={TAG_STATUS[status]}>
        {statusLabels[status]}
      </Tag>
    ),
    url: value
  }));

  return (
    <TableListV2
      className="appAndSiteMarketplaceImport__details"
      columns={[
        {
          Header: formatMessage({
            defaultMessage: 'URL',
            id: 'appAndSiteMarketplace.import.header.url'
          }),
          accessor: 'url'
        },
        {
          Header: formatMessage({
            defaultMessage: 'Type',
            id: 'appAndSiteMarketplace.import.header.type'
          }),
          accessor: 'operation'
        },
        {
          Header: formatMessage({
            defaultMessage: 'Status',
            id: 'appAndSiteMarketplace.import.header.status'
          }),
          accessor: 'status'
        }
      ]}
      config={{
        pagination: { show: true, size: 10, type: 'full' },
        type: 'list'
      }}
      data={data}
      id="appAndSiteMarketplaceImportGenericDetail"
      isSelectableList={false}
      showColumnsHeader
    />
  );
}
